import Typography from "@mui/material/Typography";
import Copyright from "../copyright/Copyright";
import Box from "@mui/material/Box";

const Footer = () => {
    return (
        <Box
            sx={{
                background: (theme) => theme.palette.secondary.main,
                width: "100%",
                paddingTop: '20px',
                paddingBottom: '10px',
                flexShrink: 0,
                borderTop: '1px solid',
                borderColor: 'divider',
            }} component="footer">
            <Typography
                variant="subtitle1"
                align="center"
                color="text.secondary"
                component="p"
            >
                Control, gestión y creación de insumos para el negocio.
            </Typography>
            <Copyright/>
        </Box>
    );
}

export default Footer;